export const createJsScript = ({scriptId, scriptUrl, parentSelector}) => {
  if (document.querySelector(scriptId)) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.setAttribute('id', scriptId);
    script.setAttribute('type', 'text/javascript');
    script.onload = resolve;
    script.setAttribute('src', scriptUrl);
    document.querySelector(parentSelector).appendChild(script);
  });
};

export const createCssLink = ({linkId, linkUrl, parentSelector}) => {
  if (document.querySelector(linkId)) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    const link = document.createElement('link');
    link.setAttribute('id', linkId);
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('crossOrigin', 'anonymous');
    link.onload = resolve;
    link.setAttribute('href', linkUrl);
    document.querySelector(parentSelector).appendChild(link);
  });
};

export const getInstrumentDataFromUrl = (params) => {
  if (params.get('popped-out') !== 'true') {
    return {
      name: null,
      settings: '',
    };
  }
  const settings = params.get('instrument-setting') || '';
  return {
    name: params.get('instrument'),
    settings: decodeURIComponent(settings),
  };
};

export const INSTRUMENT_MAP = Object.freeze({
  scope: 'nchannel-scope',
  fgen: 'function-generator',
  dmm: 'digital-multimeter',
  bode: 'bode-analyzer',
  datalogger: 'data-logger',
  vps: 'variable-power-supply',
  iv: 'iv-analyzer',
  datagenerator: 'data-generator',
  digitalio: 'digital-io',
});

export const INSTRUMENT_NAME_MAP = Object.freeze({
  scope: 'Oscilloscope',
  bode: 'Bode Analyzer',
  iv: 'Current-Voltage Analyzer',
  datalogger: 'Data Logger',
  fgen: 'Function and Arbitrary Waveform Generator',
  dmm: 'Digital Multimeter',
  vps: 'Variable Power Supply',
  datagenerator: 'Data Generator',
  digitalio: 'Digital I/O',
});

export const DataExportFormat = Object.freeze({
  csv: 1,
  tdms: 2,
});

export const downloadBlob = (blob, fileName, mimeType = 'application/octet-stream') => {
  const a = document.createElement('a');
  if (window.URL && 'download' in a) {
    a.href = window.URL.createObjectURL(new Blob([blob], {type: mimeType}));
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    location.href = 'data:application/octet-stream,' + encodeURIComponent(blob);
  }
};

export const downloadCanvas = (canvas, fileName) =>
  new Promise((resolve) => {
    canvas.toBlob((blob) => {
      downloadBlob(blob, fileName);
      resolve();
    });
  });

export const getCurrentDate = () => {
  const tzOffset = new Date().getTimezoneOffset() * 60000;
  const localTimeStr = new Date(Date.now() - tzOffset).toISOString().slice(0, -1);
  const [datePart, timePart] = localTimeStr.split('T');
  const [year, month, day] = datePart.split('-');
  const [hour, minute, second] = timePart.split('.')[0].split(':');
  return {
    year,
    month,
    day,
    hour,
    minute,
    second,
  };
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const userAgent =
  ('navigator' in window && 'userAgent' in window.navigator && window.navigator.userAgent.toLowerCase()) || '';

export const isIOS = /iphone/i.test(userAgent) || /ipad/i.test(userAgent) || /ipod/i.test(userAgent);

export const isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function(p) {
    return p.toString() === '[object SafariRemoteNotification]';
  })(!window.safari || (typeof window.safari !== 'undefined' && window.safari.pushNotification));

export const isMobile = () =>
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/webOS/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/iPod/i) ||
  navigator.userAgent.match(/BlackBerry/i) ||
  navigator.userAgent.match(/Windows Phone/i);
